/**
 * Support-request funnel helpers (SPR-1206 B).
 * Field names / flow type only — never values, emails, or amounts.
 */

export type SupportRequestAnalyticsType = 'supported' | 'fund_expense';

export const SUPPORT_REQUEST_UNKNOWN_FIELD = 'unknown';

export function supportRequestTypeFromFlow(isFundExpense: boolean): SupportRequestAnalyticsType {
  return isFundExpense ? 'fund_expense' : 'supported';
}

/** Resolve a focus target to a form field name for last_field (never values). */
export function fieldNameFromFocusTarget(target: EventTarget | null): string | undefined {
  if (!(target instanceof HTMLElement)) return undefined;
  const named = target as HTMLInputElement;
  const raw =
    (typeof named.name === 'string' && named.name) ||
    target.getAttribute('name') ||
    target.getAttribute('data-field') ||
    '';
  const trimmed = raw.trim();
  return trimmed || undefined;
}
